import {
  FormControlLabel,
  FormGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import EditButton from "components/common/EditButton";
import InfoIconButton from "components/common/InfoIconButton";
import { StyledTableCell, StyledTableRow } from "components/common/Table";
import { StatusCard } from "components/home/VisaStatusCard";
import { StyleCheckbox } from "components/request-document/components/Commons";
import PopupSelectVisaRequest from "components/section-m-24/PopupSelectVisaRequest";
import {
  M24_CONFIG_COMPANY_TO_PERSON,
  M24_CONFIG_DOC,
  RoleId,
  STATUS_PROCESS,
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash";
import mime from "mime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  selectM24SwitchMode,
  selectProjectID,
} from "redux/modules/m24SwitchModeSlice";
import {
  getPersonalDetail,
  getPersonalList,
  selectPersonalState,
} from "redux/modules/personalSlice";
import {
  selectIsChamber,
  selectSmartCompany,
} from "redux/modules/smartCompanySlice";
import {
  initRouter,
  selectEmployeeListDocTypeTab,
  setEmployeeListDocTypeTab,
  setSmartFormStep,
} from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  addTerminateSmartForm,
  // getListSmartForm,
  getSmartForm,
  getSmartFormFieldConfig,
  getVisaRequest,
  selectSmartFormFieldConfig,
  selectSubmitSmartForm,
  smartfromExtensionClone,
  submitSmartForm,
  submitSmartFormSlice,
} from "redux/modules/visaForm";
import AllDocumentsService from "services/AllDocumentsService";
import VisaFormService from "services/VisaFormService";

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(5),
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
  },
  tableContainer: {
    marginTop: theme.spacing(4),
  },
  pagination: {
    marginTop: theme.spacing(4),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  statusBottonRow: {
    display: "flex",
    flex: 1,
    gap: 23,
  },
}));

const StatusButton = [
  {
    title: "All",
    value: null,
  },
  {
    title: "Request",
    value: "R",
  },
  // {
  //   title: "Change",
  //   value: "C",
  // },
  {
    title: "Termination",
    value: "T",
  },
  {
    title: "Extension",
    value: "E",
  },
];

function PersonalListPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const history = useHistory();
  const { showLoading, hideLoading } = useModalLoading();
  const [isTriggerRefresh, setTriggerRefresh] = useState(false);
  const [isModalSelectVisaRequestVisible, setModaSelectVisaRequestVisible] =
    useState(false);
  const [rowItem, setRowItem] = useState(null);

  const [openedPopoverId, setOpenedPopoverId] = useState(null);
  const [anchorElDetail, setAnchorElDetail] = useState(null);
  const openDetail = Boolean(anchorElDetail);

  const userProfile = useSelector((state) => state.user.profile);
  const personalState = useSelector(selectPersonalState);
  const smartCompanyState = useSelector(selectSmartCompany);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const submitSmartFormState = useSelector(selectSubmitSmartForm);
  const m24SwitchMode = useSelector(selectM24SwitchMode);
  const isChamber = useSelector(selectIsChamber);
  const projectID = useSelector(selectProjectID);
  const employeeListDocTypeTab = useSelector(selectEmployeeListDocTypeTab);

  const personalList = get(personalState, "list", []);
  const smartCompanyData = get(smartCompanyState, "data", {});
  const smartCompanyID = get(smartCompanyData, "smartCompanyID", null);
  const personalId = userProfile?.userID || null;
  const isDirector = userProfile?.roleId === RoleId.Director;
  const smartserviceId =
    M24_CONFIG_DOC[m24SwitchMode]?.SMART_SERVICE_ID ?? null;
  const visaRequestID = isChamber
    ? "fca5fb58-9817-4b9c-bd9b-210a786c6a5f"
    : null;

  const [checkboxList, setCheckboxList] = useState([]);

  useEffect(() => {
    setCheckboxList([]);
  }, [employeeListDocTypeTab, isTriggerRefresh]);

  useEffect(() => {
    if (smartserviceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartserviceId }));
      dispatch(getVisaRequest({ smartserviceId: smartserviceId }));
    }
  }, [dispatch, smartserviceId]);

  useEffect(() => {
    if (smartCompanyID) {
      if (isDirector) {
        dispatch(
          getPersonalList({
            typeDocSmartFromID: employeeListDocTypeTab,
            smartCompanyID,
          })
        );
      } else {
        dispatch(
          getPersonalList({
            typeDocSmartFromID: employeeListDocTypeTab,
            smartCompanyID,
            personalId,
          })
        );
      }
    }
  }, [employeeListDocTypeTab, smartCompanyID, isDirector, isTriggerRefresh]);

  useEffect(() => {
    if (personalState.isLoading) {
      showLoading();
    } else {
      hideLoading();
    }
  }, [personalState.isLoading]);

  useEffect(() => {
    if (submitSmartFormState.isSuccess) {
      setTriggerRefresh((isTriggerRefresh) => !isTriggerRefresh);
      // dispatch(setEmployeeListDocTypeTab(null))
      dispatch(submitSmartFormSlice.actions.clearAsyncState());
    } else if (submitSmartFormState.isFailure) {
      hideLoading();
      dispatch(submitSmartFormSlice.actions.clearAsyncState());
      alert(submitSmartFormState.error?.message);
    }
  }, [submitSmartFormState.isSuccess, submitSmartFormState.isFailure]);

  const textButton = StatusButton.find(
    (c) => c.value === employeeListDocTypeTab
  )?.title;

  const handleClickView = (row) => async () => {
    if (textButton === "Request") {
      console.log("row ", row);
      if (row.statusProcessId === STATUS_PROCESS.RequestAddDoc) {
        dispatch(initRouter([SMART_T_STEP.NONE, SMART_T_STEP.UPLOAD_DOCUMENT]));

        await dispatch(getPersonalDetail({ personalId: row.personalId }));
        await dispatch(
          getSmartForm({
            personalId: row.personalId,
            draftId: row.draftId,
          })
        );
        dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        return;
      }

      dispatch(
        initRouter([
          SMART_T_STEP.EMPLOYEE_LIST,
          SMART_T_STEP.UPLOAD_PASSPORT,
          SMART_T_STEP.PART_A_1,
          SMART_T_STEP.PART_A_2,
          SMART_T_STEP.UPLOAD_DOCUMENT,
        ])
      );

      if (row.draftId) {
        try {
          showLoading();

          await dispatch(getPersonalDetail({ personalId: row.personalID }));
          await dispatch(
            getSmartForm({ personalId: row.personalID, draftId: row.draftId })
          );

          hideLoading();
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
        } catch (error) {
          hideLoading();
        }
      }
    } else if (textButton === "Termination") {
      dispatch(
        initRouter([
          SMART_T_STEP.EMPLOYEE_LIST,
          SMART_T_STEP.UPLOAD_PASSPORT,
          SMART_T_STEP.TERMINATION,
        ])
      );

      if (row.draftId) {
        try {
          showLoading();

          await dispatch(getPersonalDetail({ personalId: row.personalID }));
          await dispatch(
            getSmartForm({ personalId: row.personalID, draftId: row.draftId })
          );

          hideLoading();
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
        } catch (error) {
          hideLoading();
        }
      }
    } else if (textButton === "Extension") {
      dispatch(
        initRouter([
          SMART_T_STEP.EMPLOYEE_LIST,
          SMART_T_STEP.UPLOAD_PASSPORT,
          SMART_T_STEP.PART_A_1,
          SMART_T_STEP.PART_A_2,
          SMART_T_STEP.UPLOAD_DOCUMENT,
        ])
      );

      if (row.draftId) {
        try {
          showLoading();

          await dispatch(getPersonalDetail({ personalId: row.personalID }));
          await dispatch(
            getSmartForm({ personalId: row.personalID, draftId: row.draftId })
          );

          hideLoading();
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
        } catch (error) {
          hideLoading();
        }
      }
    }
  };

  const handleClickDoAction = (row) => async () => {
    if (textButton === "Request") {
      console.log("row ", row);
      if (row.statusProcessId === STATUS_PROCESS.RequestAddDoc) {
        dispatch(initRouter([SMART_T_STEP.NONE, SMART_T_STEP.UPLOAD_DOCUMENT]));

        await dispatch(getPersonalDetail({ personalId: row.personalId }));
        await dispatch(
          getSmartForm({
            personalId: row.personalId,
            draftId: row.draftId,
          })
        );
        dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
        return;
      }

      dispatch(
        initRouter([
          SMART_T_STEP.EMPLOYEE_LIST,
          SMART_T_STEP.UPLOAD_PASSPORT,
          SMART_T_STEP.PART_A_1,
          SMART_T_STEP.PART_A_2,
          SMART_T_STEP.UPLOAD_DOCUMENT,
        ])
      );

      if (isChamber) {
        try {
          showLoading();

          const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
          const getFieldListConfig = defaultType.filter(
            (c) => c.smartName === "ConditionType"
          );

          const prepareData = {
            draftId: null,
            survey: null,
            visaissuance: null,
            projectID: null,
            smartCompanyID: smartCompanyID,
            smartserviceId: smartserviceId,
            personalId: row.personalID,
            visaRequestID: visaRequestID,
            detail: [
              ...getFieldListConfig.map((field) => ({
                smartName: field.smartName,
                smartId: null,
                partfromId: field.partfromId,
                configsmartId: field.configsmartId,
                linkTable: field.linkTable,
                value:
                  M24_CONFIG_DOC[M24_CONFIG_COMPANY_TO_PERSON[m24SwitchMode]]
                    ?.CONDITION_TYPE,
              })),
            ],
          };
          await dispatch(getPersonalDetail({ personalId: row.personalID }));
          const res = await dispatch(addSmartForm({ data: prepareData }));
          await dispatch(
            getSmartForm({
              personalId: row.personalID,
              draftId: res.payload.draftId,
            })
          );
          hideLoading();
          dispatch(addSmartFormSlice.actions.clearAsyncState());
          dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
          dispatch(
            getPersonalList({
              typeDocSmartFromID: employeeListDocTypeTab,
              smartCompanyID,
            })
          );
        } catch (error) {
          console.log("error ", error);
          hideLoading();
        }
      } else {
        setRowItem(row);
        setModaSelectVisaRequestVisible(true);
      }
    } else if (textButton === "Termination") {
      dispatch(
        initRouter([
          SMART_T_STEP.EMPLOYEE_LIST,
          SMART_T_STEP.UPLOAD_PASSPORT,
          SMART_T_STEP.TERMINATION,
        ])
      );

      try {
        showLoading();

        const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
        const getFieldListConfig = defaultType.filter(
          (c) => c.smartName === "ConditionType"
        );

        const prepareData = {
          draftId: null,
          survey: null,
          visaissuance: null,
          visaRequestID: null,
          projectID: null,
          smartCompanyID: smartCompanyID,
          smartserviceId: smartserviceId,
          personalId: row.personalID,
          detail: [
            ...getFieldListConfig.map((field) => ({
              smartName: field.smartName,
              smartId: null,
              partfromId: field.partfromId,
              configsmartId: field.configsmartId,
              linkTable: field.linkTable,
              value:
                M24_CONFIG_DOC[M24_CONFIG_COMPANY_TO_PERSON[m24SwitchMode]]
                  ?.CONDITION_TYPE,
            })),
          ],
        };

        await dispatch(getPersonalDetail({ personalId: row.personalID }));
        const res = await dispatch(
          addTerminateSmartForm({ data: prepareData })
        );

        await dispatch(
          getSmartForm({
            personalId: row.personalID,
            draftId: res.payload.draftId,
          })
        );
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
        dispatch(
          getPersonalList({
            typeDocSmartFromID: employeeListDocTypeTab,
            smartCompanyID,
          })
        );
      } catch (error) {
        console.log("error ", error);
        hideLoading();
      }
    } else if (textButton === "Extension") {
      dispatch(
        initRouter([
          SMART_T_STEP.EMPLOYEE_LIST,
          SMART_T_STEP.UPLOAD_PASSPORT,
          SMART_T_STEP.PART_A_1,
          SMART_T_STEP.PART_A_2,
          SMART_T_STEP.UPLOAD_DOCUMENT,
        ])
      );

      try {
        showLoading();

        await dispatch(getPersonalDetail({ personalId: row.personalID }));
        const res = await dispatch(
          smartfromExtensionClone({ personalId: row.personalID })
        );

        await dispatch(
          getSmartForm({
            personalId: row.personalID,
            draftId: res.payload.draftId,
          })
        );
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
        dispatch(
          getPersonalList({
            typeDocSmartFromID: employeeListDocTypeTab,
            smartCompanyID,
          })
        );
      } catch (error) {
        console.log("error ", error);
        hideLoading();
      }
    }
  };

  const allListChecked = personalList
    .filter((row) => row.draftId && row.statusProcessName === "Draft")
    .map((c) => c.draftId);

  const handleToggleCheckAll = () => {
    const hasAllListChecked = checkboxList.length === allListChecked.length;
    if (hasAllListChecked) {
      setCheckboxList([]);
    } else {
      setCheckboxList(allListChecked);
    }
  };

  const handleOnSubmit = () => {
    showLoading();
    const prepareData = checkboxList.map((draftId) => ({ draftId }));
    console.log(prepareData);
    dispatch(submitSmartForm({ detail: prepareData }));
  };

  const handleModalSelectVisaRequestClose = () => {
    setModaSelectVisaRequestVisible(false);
  };
  const handleModalSelectVisaRequestSubmit = async (value) => {
    setModaSelectVisaRequestVisible(false);

    try {
      showLoading();

      const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
      const getFieldListConfig = defaultType.filter(
        (c) => c.smartName === "ConditionType"
      );

      // In case of BOI application is under consideration for investment promotion.
      const isInCaseBOI = value === "fca5fb58-9817-4b9c-bd9b-210a786c6a5f";
      let resRequestClone;
      let cloneDraftId = null;

      if (isInCaseBOI) {
        resRequestClone = await VisaFormService.smartfromRequestClone({
          personalId: rowItem.personalID,
        });
        cloneDraftId = resRequestClone?.results?.draftId ?? null;
      }

      const prepareData = {
        draftId: null,
        survey: null,
        visaissuance: null,
        projectID: projectID || null,
        smartCompanyID: smartCompanyID,
        smartserviceId: smartserviceId,
        personalId: rowItem.personalID,
        visaRequestID: value,
        detail: [
          ...getFieldListConfig.map((field) => ({
            smartName: field.smartName,
            smartId: null,
            partfromId: field.partfromId,
            configsmartId: field.configsmartId,
            linkTable: field.linkTable,
            value:
              M24_CONFIG_DOC[M24_CONFIG_COMPANY_TO_PERSON[m24SwitchMode]]
                ?.CONDITION_TYPE,
          })),
        ],
      };
      await dispatch(getPersonalDetail({ personalId: rowItem.personalID }));

      let res;
      if (!cloneDraftId) {
        res = await dispatch(addSmartForm({ data: prepareData }));
      }

      await dispatch(
        getSmartForm({
          personalId: rowItem.personalID,
          draftId:
            isInCaseBOI && cloneDraftId ? cloneDraftId : res.payload.draftId,
        })
      );
      hideLoading();
      dispatch(addSmartFormSlice.actions.clearAsyncState());
      dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
      dispatch(
        getPersonalList({
          typeDocSmartFromID: employeeListDocTypeTab,
          smartCompanyID,
        })
      );
    } catch (error) {
      console.log("error ", error);
      hideLoading();
    }
  };

  const colors = [
    // theme.palette.primary.main,
    // theme.palette.warning.main,
    theme.palette.secondary.main,
    theme.palette.error.main,
    theme.palette.primary.main,
  ];

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_DOCUMENT));
      }}
    >
      <ContentTitle
        subTitle="INSTITUTION/COMPANY APPLYING FOR TEMPORARY STAY FOR FOREIGNER TO STUDY INVESTMENT"
        title="Application Form"
      />
      <br />

      <div className={classes.row}>
        <div className={classes.statusBottonRow}>
          {StatusButton.filter((c) => c.title !== "All")
            .map((v, i) => ({
              ...v,
              color: colors[i],
              // v.value === employeeListDocTypeTab
              //   ? theme.palette.warning.main
              //   : theme.palette.secondary.main,
              // color: theme.palette.primary.main,
              // color: theme.palette.warning.main,
              // color: theme.palette.secondary.main,
              // color: theme.palette.error.main,
            }))
            .map((statusBt) => (
              // <ColorButton
              //   disableElevation
              //   key={statusBt.value}
              //   variant="contained"
              //   color="secondary"
              //   style={{
              //     backgroundColor:
              //       statusBt.value === employeeListDocTypeTab
              //         ? "#1094D8"
              //         : "#B0B6BA",
              //     height: 200,
              //     width: 300,
              //   }}
              //   onClick={() => {
              //     dispatch(setEmployeeListDocTypeTab(statusBt.value));
              //   }}
              // >
              //   {statusBt.title}
              // </ColorButton>
              <div
                key={statusBt.value}
                style={{
                  cursor: "pointer",
                  // borderWidth: 1,
                  // borderColor:
                  //   statusBt.value === employeeListDocTypeTab
                  //     ? theme.palette.warning.main
                  //     : "unset",
                }}
                onClick={() => {
                  dispatch(setEmployeeListDocTypeTab(statusBt.value));
                }}
              >
                <StatusCard
                  hideInfoIcon
                  hideCalloutIcon
                  title={statusBt.title}
                  subTitle=""
                  discription=""
                  color={statusBt.color}
                  customCardStyle={{
                    height: "auto",
                    ...(statusBt.value === employeeListDocTypeTab && {
                      boxShadow: theme.shadows[13],
                    }),
                  }}
                />
              </div>
            ))}
        </div>
        <div>
          <ColorButton
            variant="contained"
            color="success"
            disabled={!checkboxList.length}
            onClick={handleOnSubmit}
          >
            Submit
          </ColorButton>
        </div>
      </div>
      <div className={classes.row} style={{ marginTop: 16 }}>
        {StatusButton.filter((c) => c.title === "All").map((statusBt) => (
          <ColorButton
            disableElevation
            key={statusBt.value}
            variant="contained"
            color="secondary"
            style={{
              backgroundColor:
                statusBt.value === employeeListDocTypeTab
                  ? "#1094D8"
                  : "#B0B6BA",
            }}
            onClick={() => {
              dispatch(setEmployeeListDocTypeTab(statusBt.value));
            }}
          >
            {statusBt.title}
          </ColorButton>
        ))}
      </div>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHead}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <StyleCheckbox
                        disabled={allListChecked.length === 0}
                        checked={
                          allListChecked.length === 0
                            ? false
                            : checkboxList.length === allListChecked.length
                        }
                        onChange={() => handleToggleCheckAll()}
                      />
                    }
                    label=""
                  />
                </FormGroup>
              </TableCell>
              <TableCell className={classes.tableHead}>Frist Name</TableCell>
              <TableCell className={classes.tableHead}>Middle Name</TableCell>
              <TableCell className={classes.tableHead}>Last Name</TableCell>
              <TableCell className={classes.tableHead}>Smart No.</TableCell>
              <TableCell className={classes.tableHead}>Status</TableCell>
              <TableCell
                className={classes.tableHead}
                style={{ width: 100 }}
                align="right"
              >
                ACTION
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {personalList.map((row) => (
              <StyledTableRow key={row.personalID}>
                <StyledTableCell>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <StyleCheckbox
                          disabled={
                            !(row.draftId && row.statusProcessName === "Draft")
                          }
                          checked={checkboxList.some(
                            (draftId) => draftId === row.draftId
                          )}
                          onChange={() => {
                            const hasChecked = checkboxList.some(
                              (draftId) => draftId === row.draftId
                            );

                            if (hasChecked) {
                              setCheckboxList((list) =>
                                list.filter((v) => v !== row.draftId)
                              );
                            } else {
                              setCheckboxList((list) => [...list, row.draftId]);
                            }
                          }}
                        />
                      }
                      label=""
                    />
                  </FormGroup>
                </StyledTableCell>
                <StyledTableCell>{row.firstname || "-"}</StyledTableCell>
                <StyledTableCell>{row.middleName || "-"}</StyledTableCell>
                <StyledTableCell>{row.lastName || "-"}</StyledTableCell>
                <StyledTableCell>{row.smartNo || "-"}</StyledTableCell>
                <StyledTableCell>
                  {row.statusProcessName || "-"}
                </StyledTableCell>
                <StyledTableCell>
                  <div className={classes.row}>
                    {textButton !== "All" && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: 8,
                        }}
                      >
                        <EditButton
                          title="View"
                          disabled={!row.draftId}
                          onClick={handleClickView(row)}
                        />
                      </div>
                    )}
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {textButton !== "All" && (
                        <ColorButton
                          variant="contained"
                          color="info"
                          style={{
                            backgroundColor: "#00D0FF",
                            fontWeight: "bold",
                          }}
                          onClick={handleClickDoAction(row)}
                        >
                          {textButton}
                        </ColorButton>
                      )}
                    </div>
                    <InfoIconButton
                      aria-describedby="mouse-over-detial-popover"
                      onClick={(event) => {
                        if (row.draftId) {
                          setOpenedPopoverId(row.draftId);
                          setAnchorElDetail(event.currentTarget);
                        }
                      }}
                    />
                    {row.draftId && (
                      <Popover
                        open={openDetail && openedPopoverId === row.draftId}
                        anchorEl={anchorElDetail}
                        onClose={() => {
                          setOpenedPopoverId(null);
                          setAnchorElDetail(null);
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                      >
                        <List component="nav">
                          <ListItem button>
                            <ListItemText
                              primary="Download"
                              onClick={async () => {
                                setOpenedPopoverId(null);
                                setAnchorElDetail(null);
                                showLoading();

                                try {
                                  const draftId = row.draftId;
                                  const filename = draftId + ".pdf";
                                  const blob =
                                    await AllDocumentsService.downloadSummaryReport(
                                      draftId
                                    );
                                  const blobFile = new File([blob], filename, {
                                    type: mime.getType(".pdf"),
                                  });

                                  window.open(
                                    URL.createObjectURL(blobFile),
                                    "_blank"
                                  );
                                } catch (error) {
                                  alert(JSON.stringify(error));
                                }

                                hideLoading();
                              }}
                            />
                          </ListItem>
                        </List>
                      </Popover>
                    )}
                  </div>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        open={isModalSelectVisaRequestVisible}
        onClose={handleModalSelectVisaRequestClose}
        maxWidth="lg"
        keepMounted={false}
        id="PopupSelectVisaRequest"
      >
        <DialogContent>
          <PopupSelectVisaRequest
            onCancel={handleModalSelectVisaRequestClose}
            onSubmit={handleModalSelectVisaRequestSubmit}
          />
        </DialogContent>
      </Dialog>
    </form>
  );
}

export default PersonalListPage;
